export const ProfileRoutes = {
  Overview: 'overview',
  Create: 'create',
  Detail: 'detail',
} as const;
